// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DateInput{padding:0px}.DateInput .DateInput_input{line-height:15px;font-size:14px;font-weight:normal;padding:10px 11px 9px}\n", ""]);
// Exports
module.exports = exports;
